import { isSaasAdmin } from '@crm/shared';
import { useSession } from './use-session';

export function useIsSaasAdmin(): boolean {
  const { user } = useSession();

  return isSaasAdmin(user);
}
